const getDateFromISO = (dateText: string): Date => {
  return new Date(dateText);
};

export default getDateFromISO;
